import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import Typography from "./Typography";
import IconBadge from "./IconBadge";

const SectionCard = ({ title, icon: Icon, children, delay = 0 }) => (
  <motion.section
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3, ease: "easeOut", delay }}
    className="relative overflow-hidden border border-insight-border bg-insight-screen p-5 shadow-insight-inset rounded-lg"
  >
    <div className="absolute inset-0 hero-atom-grain pointer-events-none" />
    <div className="relative z-10">
      <div className="mb-4 flex items-center gap-3 pb-3 border-b border-insight-border">
        <IconBadge size="md">
          <Icon className="h-5 w-5 text-primary" />
        </IconBadge>
        <Typography variant="h4" className="text-foreground">
          {title}
        </Typography>
      </div>
      {children}
    </div>
  </motion.section>
);

SectionCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  children: PropTypes.node,
  delay: PropTypes.number,
};

export default SectionCard;
